import React from 'react';
import Headicon from '../../../../asset/headicon.png';
import '../../../../app/home/section/aboutcookapp/aboutcookapp.css'
import Faq from "react-faq-component";
import Userapp from '../../../../asset/userapp.png'

const Aboutcookapp = () => {

  const data = {
    // title: "FAQ (How it works)",
    rows: [
      {
        title: "Vendors invite,",
        content: `Welcome to our advanced e-commerce site, where convenience meets purchasing! We are happy to provide a 
        simplified online purchasing experience that will meet all of your needs. We've got you covered if you're looking 
        for the most recent food delivery, plants, and nursery, pick-up and drop-off service, home service.`,
      },

    ],
  };

  const styles = {
    bgColor: 'white',
    // titleTextColor: "#4d4d4d",
    // rowTitleColor: "4d4d4d",
    // rowContentColor: 'grey',
    arrowColor: "#028149",
    transitionDuration: ".5s",
    timingFunc: "ease",
    rowTitleTextSize: '20px',

  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    tabFocus: true
  };


  return (
    <div className={'cookapp'}>
      <div className={'pad'}>
        <div className={'row'}>
          <div >

          </div>
          <div className={'col-lg-7 mt-3'}>
            <div className={'cl-lg-12 headicon'}>
              <img src={Headicon} />
              <h1 className={'mt-3'}>About <span>Homee Vendor App</span></h1>
            </div>
            <div>
              {/* <Faq
                data={data}
                styles={styles}
                config={config}
                className={'faq'}

              /> */}
              <p>
                {/* HOMEE, which now connects small eateries, regular caterers, and homemakers for delivering homely-type foods, including home-made batters and
                condiments, in Town for some time, Developing its platform to bring in other services soon. It has more than 600 kitchens in Chennai and 100
                in Hyderabad and adds to its Kitchen base on a daily basis. HOMEE will be a mini-super App for Regular home-based and restaurant foods, Delivery
                services, Home Garden products, copoeat, Home Keeping services, and others. The HOMEE name was coined to meet most of the home's needs through its
                tech platform. HOMEE Brand aims to become a key Tech Member in every house over time. */}
                <br />
                HOMEE is owned by First Gen E-COM India Pvt. Ltd., founded by K. Raman and Sowmya in 2022 and developed with the support of their dedicated team. HOMEE aims to bring over 100,000 active users onto the platform by March 2026.
                The promoters’ long-term vision is to make this green-service model fully EBITDA-positive at the earliest by reducing customer acquisition costs and offering all gardening services, plant-care solutions, and green-related products under a single mobile application, minimizing cash burn.
                In the coming days, HOMEE will also introduce subscription-based garden care plans to build sustainable revenue streams.
                <br /><br />
                HOMEE includes a unique feature that allows users to schedule their gardening services in advance, helping them plan plant maintenance, landscaping, watering routines, and garden checkups for the upcoming week.
                The HOMEE One-to-One service will be especially beneficial for senior citizens, plant lovers, and busy professionals who rely on daily or regular garden maintenance. The app enables doorstep delivery of plants, tools, fertilizers, soil mixes, and
                other green essentials—ideal for users who are not familiar with online ordering.
                <br /><br />
                HOMEE understands that independent gardeners, nursery owners, and plant suppliers often struggle to grow their customer base due to the lack of delivery support and limited digital reach.
                HOMEE bridges this gap by creating a strong ecosystem that connects gardening professionals and
                nurseries with customers through one smooth and accessible platform.
                <br /><br />
                At present, the company is self-funded by the promoters and is seeking equity or strategic investors to expand its green services to more cities in the near future.
              </p>
            </div>
          </div>
          <div className={'col-lg-5 px-5'}>
            <div>
              <img src={Userapp} width="100%" />
            </div>
          </div>
        </div>


      </div>
    </div>
  )
}

export default Aboutcookapp;